module.exports = __webpack_public_path__ + "638647a6014514cc6a28cee42abeb25d.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/MH.svg
// module id = PFpk
// module chunks = 0